<app-modal-filler-atom
  (onClick)="close()"
  [index]="5"
></app-modal-filler-atom>
<div
  data-testid="bogof-modal"
  class="fixed bottom-0 left-0 right-0 mx-auto w-full md:inset-0 md:flex md:items-center md:justify-center md:p-4"
  [style.z-index]="750"
>
  @if (isDesktop()) {
    <app-modal-filler-atom
      [withBackdrop]="false"
      (onClick)="close()"
      [index]="index()"
    ></app-modal-filler-atom>
  }
  <div
    [style.z-index]="index() + 50"
    class="flex max-h-85-screen w-full flex-col gap-6 overflow-y-auto rounded-t-3xl bg-white py-8 text-center md:max-h-[90vh] md:rounded-3xl lg:p-5 kiosk:px-16"
    [class]="resolvedModalMode() === 'products' ? 'max-w-[900px]' : 'max-w-[700px]'"
  >
    <div class="space-y-5 px-4.5 py-5">
      <!-- <div> -->
      <div class="flex items-start gap-x-4">
        <div class="flex flex-1 items-start">
          <span class="font-base font-bold text-left lg:text-md kiosk:text-3.5xl">{{
            resolvedPromotionName()
          }}</span>
        </div>
        <button
          (click)="close()"
          class="icon icon-cross self-start h-8 w-8 rounded-full text-xs kiosk:h-16 kiosk:w-16 kiosk:text-3xl"
          [style.backgroundColor]="
            closeIconColors()?.background | contentBuilderColor: 'var(--ui-color-primary-200)'
          "
          [style.color]="
            closeIconColors()?.font | contentBuilderColor: 'var(--ui-color-primary-900)'
          "
        ></button>
      </div>

      <div class="flex flex-col gap-5 overflow-scroll scrollbar-hide">
        @if (resolvedModalMode() === 'products') {
          @if (resolvedLoading()) {
            <!-- Mobile skeleton -->
            <div class="flex flex-col gap-4 md:hidden">
              @for (_ of loadingCards(); track $index) {
                <div
                  class="flex h-[120px] w-full overflow-hidden rounded-lg border border-neutral-100 bg-white"
                >
                  <div class="h-full w-[38%] animate-pulse bg-neutral-50"></div>
                  <div class="flex flex-1 flex-col justify-center gap-3 px-4">
                    <div class="h-4 w-10/12 animate-pulse rounded bg-neutral-100"></div>
                    <div class="h-4 w-7/12 animate-pulse rounded bg-neutral-100"></div>
                    <div class="h-4 w-8/12 animate-pulse rounded bg-neutral-100"></div>
                  </div>
                </div>
              }
            </div>
            <!-- Desktop skeleton -->
            <div
              class="hidden gap-4 md:grid"
              [class.grid-cols-2]="desktopPageSize() === 2"
              [class.grid-cols-3]="desktopPageSize() === 3"
            >
              @for (_ of desktopLoadingCards(); track $index) {
                <div class="overflow-hidden rounded-lg border border-neutral-100 bg-white">
                  <div class="h-[220px] w-full animate-pulse bg-neutral-50"></div>
                  <div class="space-y-3 p-3">
                    <div class="h-4 w-10/12 animate-pulse rounded bg-neutral-100"></div>
                    <div class="h-4 w-4/12 animate-pulse rounded bg-neutral-100"></div>
                    <div class="h-4 w-7/12 animate-pulse rounded bg-neutral-100"></div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="relative md:hidden">
              <div class="relative">
                <div
                  #mobileProductsScroller
                  class="flex max-h-[52vh] flex-col gap-4 overflow-y-auto pr-1 scrollbar-hide"
                >
                  @for (product of productsWithOfferPrice(); track product.id) {
                    <div class="flex w-full flex-col">
                      @if (deviceIsKiosk() || !isMobile()) {
                        <app-kiosk-product-card-factory
                          [product]="product"
                          [quantity]="product.quantity"
                          (addProduct)="addProductDispatcher(product)"
                          (showProduct)="openProductModal(product)"
                          [isProductAvailable]="
                            !!product.available && !unAvailableProductById()[product.id]
                          "
                          [textColor]="textColor()"
                          [cardColor]="cardColor()"
                          [buttonBackgroundColor]="buttonBackgroundColor()"
                          [unavailableButtonBackground]="unavailableButtonBackground()"
                          [unavailableButtonText]="unavailableButtonText()"
                          [buttonTextColor]="buttonTextColor()"
                          [priceColor]="priceColor() ?? defaultPriceColor"
                          [isShowProductIcon]="false"
                          class="flex-1"
                        ></app-kiosk-product-card-factory>
                      } @else {
                        <button
                          type="button"
                          class="flex w-full overflow-hidden rounded-xl border border-neutral-200 bg-white text-left shadow-sm"
                          [class.opacity-50]="
                            !product.available || unAvailableProductById()[product.id]
                          "
                          [disabled]="!product.available || unAvailableProductById()[product.id]"
                          (click)="addProductDispatcher(product)"
                        >
                          <div class="relative w-[38%] shrink-0 overflow-hidden bg-neutral-50">
                            @if (product.images?.thumbnail?.url) {
                              <img
                                [src]="product.images?.thumbnail?.url"
                                [alt]="product.name"
                                class="absolute inset-0 h-full w-full object-cover"
                              />
                            }
                          </div>
                          <div class="flex min-w-0 flex-1 flex-col justify-between p-4">
                            <div>
                              <p class="font-bold text-neutral-900">{{ product.name }}</p>
                              <p class="text-sm text-neutral-500">
                                {{ 'bogof.price-offert' | translate }}
                              </p>
                            </div>
                            <span
                              class="mt-3 inline-flex items-center justify-center rounded-full border border-neutral-900 px-4 py-2 text-sm font-medium"
                            >
                              {{ 'product-add-modal.add-to-cart' | translate }}
                            </span>
                          </div>
                        </button>
                      }
                    </div>
                  }
                </div>
                @if (showMobileScrollShadow()) {
                  <div
                    class="pointer-events-none absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent"
                  ></div>
                }
              </div>
            </div>
            <div class="hidden w-full md:flex">
              <div class="flex w-full items-center gap-2 md:gap-3">
                @if (showDesktopCarousel()) {
                  <button
                    type="button"
                    class="icon icon-arrow-left h-9 w-9 shrink-0 rounded-full bg-primary-100 text-sm text-primary-900 disabled:opacity-30"
                    [disabled]="desktopCarouselIndex() === 0"
                    (click)="previousDesktopPage()"
                  ></button>
                }
                <div class="flex min-w-0 flex-1 justify-center">
                  <div
                    data-testid="bogof-desktop-products"
                    [class]="desktopProductsLayout().rowClass"
                  >
                    @for (product of desktopDisplayedProducts(); track product.id) {
                      <div [class]="desktopProductsLayout().cardClass">
                        <app-kiosk-product-card-factory
                          [product]="product"
                          [quantity]="product.quantity"
                          (addProduct)="addProductDispatcher(product)"
                          (showProduct)="openProductModal(product)"
                          [isProductAvailable]="
                            !!product.available && !unAvailableProductById()[product.id]
                          "
                          [textColor]="textColor()"
                          [cardColor]="cardColor()"
                          [buttonBackgroundColor]="buttonBackgroundColor()"
                          [unavailableButtonBackground]="unavailableButtonBackground()"
                          [unavailableButtonText]="unavailableButtonText()"
                          [buttonTextColor]="buttonTextColor()"
                          [priceColor]="priceColor() ?? defaultPriceColor"
                          [isShowProductIcon]="false"
                          class="flex-1"
                        ></app-kiosk-product-card-factory>
                      </div>
                    }
                  </div>
                </div>
                @if (showDesktopCarousel()) {
                  <button
                    type="button"
                    class="icon icon-arrow-right h-9 w-9 shrink-0 rounded-full bg-primary-100 text-sm text-primary-900 disabled:opacity-30"
                    [disabled]="desktopCarouselIndex() >= maxDesktopCarouselIndex()"
                    (click)="nextDesktopPage()"
                  ></button>
                }
              </div>
            </div>
          }
        } @else if (resolvedModalMode() === 'same-product') {
          <p class="text-left kiosk:text-2xl">
            {{ 'bogof.heading' | translate }}
          </p>
          <div class="flex flex-col gap-4 kiosk:gap-6">
            <button
              type="button"
              class="flex w-full items-center justify-between gap-4 rounded-lg border border-neutral-300 px-4 py-3 text-left transition hover:bg-neutral-50 kiosk:px-6 kiosk:py-5"
              (click)="yesSameProduct()"
            >
              <div class="flex min-w-0 flex-1 flex-col gap-1">
                <span class="font-bold text-neutral-900 kiosk:text-2xl">{{
                  'bogof-same-but-different-product-modal.ctaSameProductTitle' | translate
                }}</span>
                <span class="text-sm text-neutral-600 kiosk:text-xl">{{
                  'bogof-same-but-different-product-modal.ctaSameProductSubtitle' | translate
                }}</span>
              </div>
              <i class="icon icon-chevron-down -rotate-90 shrink-0 text-xs text-neutral-600"></i>
            </button>
            @if (resolvedIsComposition()) {
              <button
                type="button"
                class="flex w-full items-center justify-between gap-4 rounded-lg border border-neutral-300 px-4 py-3 text-left transition hover:bg-neutral-50 kiosk:px-6 kiosk:py-5"
                (click)="sameProductChangeConfig()"
              >
                <div class="flex min-w-0 flex-1 flex-col gap-1">
                  <span class="font-bold text-neutral-900 kiosk:text-2xl">{{
                    'bogof-same-but-different-product-modal.ctaChangeConfigTitle' | translate
                  }}</span>
                  <span class="text-sm text-neutral-600 kiosk:text-xl">{{
                    'bogof-same-but-different-product-modal.ctaChangeConfigSubtitle' | translate
                  }}</span>
                </div>
                <i class="icon icon-chevron-down -rotate-90 shrink-0 text-xs text-neutral-600"></i>
              </button>
            }
          </div>
        } @else {
          <p
            class="mb-4 w-full py-3 text-center text-sm font-semibold text-neutral-700 kiosk:py-5 kiosk:text-2xl"
          >
            {{ 'bogof.heading' | translate }}
          </p>
          <div class="flex flex-col gap-4 kiosk:gap-6">
            <button
              type="button"
              class="flex w-full items-center justify-between gap-4 rounded-lg border border-neutral-300 px-4 py-3 text-left transition hover:bg-neutral-50 kiosk:px-6 kiosk:py-5"
              (click)="yesSameProduct()"
            >
              <div class="flex min-w-0 flex-1 flex-col gap-1">
                <span class="font-bold text-neutral-900 kiosk:text-2xl">{{
                  'bogof-same-but-different-product-modal.ctaSameProductTitle' | translate
                }}</span>
                <span class="text-sm text-neutral-600 kiosk:text-xl">{{
                  'bogof-same-but-different-product-modal.ctaSameProductSubtitle' | translate
                }}</span>
              </div>
              <i class="icon icon-chevron-down -rotate-90 shrink-0 text-xs text-neutral-600"></i>
            </button>
            <button
              type="button"
              class="flex w-full items-center justify-between gap-4 rounded-lg border border-neutral-300 px-4 py-3 text-left transition hover:bg-neutral-50 kiosk:px-6 kiosk:py-5"
              (click)="sameProductChangeConfig()"
            >
              <div class="flex min-w-0 flex-1 flex-col gap-1">
                <span class="font-bold text-neutral-900 kiosk:text-2xl">{{
                  'bogof-same-but-different-product-modal.ctaChangeConfigTitle' | translate
                }}</span>
                <span class="text-sm text-neutral-600 kiosk:text-xl">{{
                  'bogof-same-but-different-product-modal.ctaChangeConfigSubtitle' | translate
                }}</span>
              </div>
              <i class="icon icon-chevron-down -rotate-90 shrink-0 text-xs text-neutral-600"></i>
            </button>
            <button
              type="button"
              class="flex w-full items-center justify-between gap-4 rounded-lg border border-neutral-300 px-4 py-3 text-left transition hover:bg-neutral-50 kiosk:px-6 kiosk:py-5"
              (click)="showOtherProductsFromSelection()"
            >
              <div class="flex min-w-0 flex-1 flex-col gap-1">
                <span class="font-bold text-neutral-900 kiosk:text-2xl">{{
                  'bogof-same-but-different-product-modal.ctaOtherProductTitle' | translate
                }}</span>
                <span class="text-sm text-neutral-600 kiosk:text-xl">{{
                  'bogof-same-but-different-product-modal.ctaOtherProductSubtitle' | translate
                }}</span>
              </div>
              <i class="icon icon-chevron-down -rotate-90 shrink-0 text-xs text-neutral-600"></i>
            </button>
          </div>
        }
      </div>
    </div>
    @if (!resolvedLoading()) {
      <div class="pt-3 shadow-top md:pt-0 md:shadow-none">
        <div class="px-4.5 md:px-0">
          <button
            type="button"
            class="w-full py-3 text-center text-sm font-semibold text-neutral-700 underline-offset-2 hover:underline kiosk:py-5 kiosk:text-2xl"
            (click)="close()"
          >
            {{ 'bogof.continue-without-offered-product' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
